import { render, staticRenderFns } from "./ViewFilter.vue?vue&type=template&id=afb8cf04"
import script from "./ViewFilter.vue?vue&type=script&lang=js"
export * from "./ViewFilter.vue?vue&type=script&lang=js"
import style0 from "./ViewFilter.vue?vue&type=style&index=0&id=afb8cf04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports